var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"b5-na-hradzi"},[_c('SvgMap',{ref:"b5mapa",attrs:{"map":_vm.mapData,"path-click":_vm.pathClick,"marker-click":_vm.markerClick}})],1),(_vm.floor && _vm.building)?_c('Podlazie',{ref:"floor",attrs:{"stage":_vm.stage,"floor":_vm.floor,"building":_vm.building,"filter":_vm.filter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }